"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Container = _interopRequireDefault(require("../../Utils/Container"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Section = _styledComponents["default"].section.withConfig({
  displayName: "News__Section",
  componentId: "sc-15i9enf-0"
})(["columns:2 325px;margin:2rem 0;>:first-child,>:last-child{margin-top:0;}"]);

var News = function News(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(Section, null, children));
};

News.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].node, _propTypes["default"].object]).isRequired
};
var _default = News;
exports["default"] = _default;